import { useQuery } from "@tanstack/react-query";

import { getStage } from "@/adapters/api";
import { stageKeys } from "../utils/query-keys.ts";

export function useStage(
	constructionId: string | undefined,
	stageId: string | undefined,
) {
	return useQuery({
		queryKey: stageKeys.detail(constructionId, stageId),
		queryFn: () =>
			// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
			getStage(constructionId!, stageId!),
		enabled: !!constructionId && !!stageId,
		retry: false,
	});
}
